export var OrderDirection;

(function (OrderDirection) {
  OrderDirection["Asc"] = "ASC";
  OrderDirection["Desc"] = "DESC";
})(OrderDirection || (OrderDirection = {}));

export var DEFAULT_PAGE_SIZE = 50;